import styled from '../../../../styles/theme';
import { ModalStyled } from '../../ModalStyled';

export const ModalStyledOV = styled(ModalStyled)`
    .option-detail {
        &__category {
            color: ${({ theme }) => theme.colors.black1};
        }

        &__title {
            color: ${({ theme }) => theme.colors.black1};
        }

        &__description {
            color: ${({ theme }) => theme.colors.black1};
        }
    }
`;
